'use strict'

import { combineReducers } from 'redux';
import update from 'immutability-helper';

import * as types from './types';
import * as aTypes from '@/state/domains/assignments/types';
import * as llTypes from '@/state/domains/locationList/types';

const byId = (state = {}, action) => {

	let locations;

	switch (action.type) {

		case aTypes.GET_ASSIGNMENTS_COMPLETED:

			({ locations } = action.data);

			const byId = locations.reduce(
				(byId, l) => ({
					...byId,
					[ l._id ]: l,
				}),
				{}
			);

			return {
				...state,
				...byId,
			};

		case llTypes.POST_ADD_TO_ROUTE_COMPLETED:

			const { location } = action.data;

			return {
				...state,
				[ location._id ]: location,
			};

		default:
			return state;
	}
};

const allIds = (state = [], action) => {

	let locations;

	switch (action.type) {

		case aTypes.GET_ASSIGNMENTS_COMPLETED:

			({ locations } = action.data);

			const ids = locations.map(l => l._id);

			return [ ...new Set([ ...state, ...ids ]) ];

		case llTypes.POST_ADD_TO_ROUTE_COMPLETED:

			const { location } = action.data;

			return [ ...new Set([ ...state, location._id ]) ];

		default:
			return state;
	}
};

export default combineReducers({
    byId,
    allIds,
});
